export default "__VITE_ASSET__DuNd3OKI__"